// extracted by mini-css-extract-plugin
export default {"container":"FluidPageLayout_container__KvYK2"};